import { z } from 'zod';
import { RegionSchema } from '../region';

export const routeRegionSchema = RegionSchema.model.pick({
  _id: true,
  customCode: true,
  displayName: true,
  boundaries: true,
  type: true,
  center: true,
});
export type RouteRegion = z.infer<typeof routeRegionSchema>;
